import * as styles from "./SimpleSignPostCarouselCard.module.scss";

import React from "react";
import Button from "../../common/Button";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

const MAX_CHARACTER_COUNT = 36;
export const SimpleSignPostCarouselCard: React.FC<
	DogsTrust.SignPostCardProps
> = ({ imgSrc, imgAlt, title, buttonLabel, buttonUrl, externalUrl }) => {
	const getShortText = () => {
		if (title.length > MAX_CHARACTER_COUNT)
			return `${title.slice(0, MAX_CHARACTER_COUNT)}...`;
		return title;
	};
	return (
		<article className={styles.cardwrapper}>
			<div className={styles.card}>
				<div className={styles.image}>
					<div className={styles.customborderprovider}>
						<ProcessedImage
							className={styles.cardimg}
							src={imgSrc}
							dimensions="400x300"
							width={220}
							height={165}
							alt={imgAlt || title}
							loading={"lazy"}
						/>
					</div>
				</div>
				<div className={styles.details}>
					<h2 data-variation="hideFromJumpLinks" className={styles.title}>
						{getShortText()}
					</h2>
					<Button
						variant={"primary"}
						size="small"
						url={buttonUrl}
						externalUrl={externalUrl}
					>
						{buttonLabel}
					</Button>
				</div>
			</div>
		</article>
	);
};

export default SimpleSignPostCarouselCard;
